import { ColDef, ITooltipParams, ValueFormatterParams } from 'ag-grid-community'
import { ColDefWithLoading } from 'components/core-v2'

import { ReconciliationTableRowData } from '../reconciliation-utilities/map-data'
import { AssetNameCell, AssetNameLoadingCell } from './asset-name-cell'
import { DifferenceCell } from './difference-cell'

export const DEFAULT_COLUMN_OPTIONS: ColDef = {
  sortable: true,
  unSortIcon: true,
  wrapText: true,
  wrapHeaderText: true,
  autoHeight: true
}

const numberFormat = ({ value }: ValueFormatterParams<ReconciliationTableRowData, number>) =>
  value?.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 6 })

const COLUMN_DEFS_WITH_LOADING: ColDefWithLoading[] = [
  {
    headerName: 'Name',
    field: 'assetName',
    sort: 'asc',
    flex: 0.225,
    cellRenderer: AssetNameCell,
    loadingCellRenderer: AssetNameLoadingCell
  },
  {
    headerName: 'Finswitch fund code',
    field: 'fundCode',
    flex: 0.155,
    loadingCellWidth: 'md'
  },
  {
    headerName: 'Holdings balance on Finswitch',
    field: 'executionAgentHoldings',
    flex: 0.155,
    loadingCellWidth: 'md',
    valueFormatter: numberFormat
  },
  {
    headerName: 'Available Transfer Balance',
    field: 'availableTransferBalance',
    flex: 0.155,
    loadingCellWidth: 'md',
    valueFormatter: numberFormat
  },
  {
    headerName: 'Internal Holdings',
    field: 'internalHoldings',
    flex: 0.155,
    loadingCellWidth: 'md',
    valueFormatter: numberFormat
  },
  {
    headerName: 'Difference',
    field: 'difference',
    flex: 0.155,
    loadingCellWidth: 'md',
    type: 'rightAligned',
    cellRenderer: DifferenceCell,
    tooltipValueGetter: ({ data }: ITooltipParams<ReconciliationTableRowData>) => {
      if (data?.breaking) return 'Finswitch Balance is less than Internal Holding'
      if (data?.warning) return 'Difference is due to unknown asset/an operational break'
      return undefined
    }
  }
]

// Export version with loading properties for LoadingTable component
export const COLUMN_DEFS_FOR_LOADING = COLUMN_DEFS_WITH_LOADING

// Export version without custom loading properties for regular Table component
export const COLUMN_DEFS: ColDef[] = COLUMN_DEFS_WITH_LOADING.map(
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  ({ loadingCellRenderer, loadingCellWidth, ...colDef }) => colDef
)
